import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const ReferenceBookTableFields = lazy(() => import("@/pages/ReferenceBooks/Rules/TableFields/ReferenceBookTableFields"));
const ReferenceBookB24FieldMapping = lazy(() => import("@/pages/ReferenceBooks/Lists/B24FieldMapping/ReferenceBookB24FieldMapping"));
const ReferenceBookSyncGroupFields = lazy(() => import("@/pages/ReferenceBooks/Lists/SyncGroupFields/ReferenceBookSyncGroupFields"));
const ReferenceBookB24Stages = lazy(() => import("@/pages/ReferenceBooks/Lists/B24Stages/ReferenceBookB24Stages"));
const ReferenceBookChecksumErrors = lazy(() => import("@/pages/ReferenceBooks/Lists/ChecksumErrors/ReferenceBookChecksumErrors"));

const urlsConfig = new UrlsConfig();

export function referenceBookBitrixRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookTableFields.to} element={<ReferenceBookTableFields/>}/>
          <Route path={urlsConfig.referenceBookB24FieldMapping.to} element={<ReferenceBookB24FieldMapping/>}/>
          <Route path={urlsConfig.referenceBookSyncGroupFields.to} element={<ReferenceBookSyncGroupFields/>}/>
          <Route path={urlsConfig.referenceBookB24Stages.to} element={<ReferenceBookB24Stages/>}/>
          <Route path={urlsConfig.referenceBookChecksumErrors.to} element={<ReferenceBookChecksumErrors/>}/>
      </>
    );
}
